module.exports = __webpack_public_path__ + "static/media/medal-solid.89b1dd7d.svg";